import { useLayoutEffect, useSyncExternalStore } from 'react';

// usePageHeader({ title, actions, filters }) — a migrated page registers its header with the shell, which renders
// it through src/ui PageHeader. Unmigrated pages keep their own .topbar and never call this.
// A tiny external store, so the header slot re-renders without re-rendering the page that registered it.
let spec = null;
const listeners = new Set();
const emit = () => listeners.forEach(l => l());

export function usePageHeader(next) {
  useLayoutEffect(() => { spec = next; emit(); });            // every render: actions may close over fresh state
  useLayoutEffect(() => () => { spec = null; emit(); }, []);  // unregister on unmount
}

export function usePageHeaderSpec() {
  return useSyncExternalStore(cb => { listeners.add(cb); return () => listeners.delete(cb); }, () => spec, () => null);
}
